import { useEffect } from "react";
import { useLoaderData } from "react-router";
import TagManager from "react-gtm-module";

import styles from "./ArticleShare.module.css";

const PUB_GTM_IDS: Record<string, string> = {
  st: "GTM-KM32VP9",
  zb: "GTM-P7LM5QD",
  bt: "GTM-P2CFV3M",
  bh: "GTM-NPK3V8K",
  tm: "GTM-NQDD3N5",
  bm: "GTM-NQDD3N5",
  mm: "GTM-NQDD3N5",
  sm: "GTM-PMHW2G7",
  tabla: "GTM-T9DK6K6",
};

export type ArticleShareLoaderData = {
  title: string;
  description: string;
  image: string | null;
  url: string;
  siteName: string;
  lang: string;
  articleUrl: string;
  issueDate: string;
  logoPath: string;
  brandColor: string;
  pub: string;
};

export default function ArticleSharePage() {
  const loaderData = useLoaderData<{ payload: ArticleShareLoaderData }>();
  const data = loaderData.payload;

  useEffect(() => {
    const gtmId = PUB_GTM_IDS[data.pub];
    if (!gtmId || typeof window === "undefined") return;

    const w = window as unknown as Window & {
      dataLayer: Record<string, unknown>[];
    };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: "gaEvent",
      event_name: "pages_page_view",
      event_details: {
        article_headline: data.title,
        article_html_url: data.articleUrl,
        publication_name: data.pub,
        context: "pages_view",
      },
    });

    TagManager.initialize({ gtmId });
    (window as any).gtmInitialized = true;
  }, [data.pub, data.title, data.articleUrl]);

  return (
    <div
      className={styles.page}
      style={{ "--brand-color": data.brandColor } as React.CSSProperties}
    >
      <header className={styles.header}>
        <div className={styles.publicationHeader}>
          <img
            src={data.logoPath}
            alt={`${data.siteName} Logo`}
            className={styles.publicationLogo}
          />
        </div>
      </header>

      <main className={styles.main}>
        {data.issueDate && (
          <div className={styles.articleDate}>{data.issueDate}</div>
        )}
        <iframe
          className={styles.articleIframe}
          src={data.articleUrl}
          title={data.title}
        />
      </main>
    </div>
  );
}
